import {SET_DELIVERY_DATE, UPDATE_CHECKOUT_FIELD, UPDATE_ERRORS, UPDATE_ZASILKOVNA} from '../actions/actionTypes';

export const INITIAL_STATE = {
    name: '',
    email: '',
    phone: '',
    note: '',
    street: '',
    city: '',
    zip: '',
    company: '',
    deliveryType: null,
    paymentType: null,
    deliveryName: '',
    deliveryPhone: '',
    deliveryCountry: null,
    deliveryDate: null,
    newsletter: false,
    zasilkovna: null,
    discount: null,
    errors: []
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case UPDATE_CHECKOUT_FIELD:
            const update = {};
            update[action.payload.key] = action.payload.value;
            return Object.assign({}, state, update);


        case UPDATE_ZASILKOVNA:
            return { ...state, zasilkovna: action.payload };
        case UPDATE_ERRORS:
            return { ...state, errors: action.payload };

        case SET_DELIVERY_DATE:
            return { ...state, deliveryDate: action.payload };

        default:
            return state;
    }
}
